import { useState, useEffect } from 'react';
import {
  TextField,
  Autocomplete,
  Box,
  createStyles,
  InputBase,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import axiosPixLink from 'config/axiosPixLink';
import { customStyle } from './CustomAutocompleteStyle';
import { PIXLINK_REDAC_STATUS } from 'utils/Constants';
const useStyles = makeStyles(() => createStyles(customStyle));
export const NetlinkingCommandedRedactionStatus = ({
  onListChange,
  highlightedOptions,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(null);
  const [statusList, setStatusList] = useState([
    {
      text: t('A commander'),
      status: PIXLINK_REDAC_STATUS.TO_BE_LAUNCHED,
    },
    {
      text: t('en cours de rédaction'),
      status: PIXLINK_REDAC_STATUS.REDACTION_IN_PROGRESS,
    },
    {
      text: t('à valider super admin'),
      status: PIXLINK_REDAC_STATUS.TO_BE_VALIDTED_SUPER_ADMIN,
    },
    {
      text: t('à valider client '),
      status: PIXLINK_REDAC_STATUS.TO_BE_VALIDTED_CLIENT,
    },
    {
      text: t('validé client, à publier'),
      status: PIXLINK_REDAC_STATUS.TO_BE_PUBLISHED,
    },
    { text: t('publié'), status: PIXLINK_REDAC_STATUS.PUBLISHED },
    { text: t('à modifier'), status: PIXLINK_REDAC_STATUS.TO_BE_MODIFIED },
    {
      text: t('en cours de repasse'),
      status: PIXLINK_REDAC_STATUS.REPASSING_IN_PROGRESS,
    },
  ]);

  const handleChange = (event, newValue) => {
    setValue([]);
    onListChange(newValue);
  };
  return (
    <Autocomplete
      value={value}
      limitTags={0}
      sx={{
        '& .MuiAutocomplete-inputRoot': {
          height: '40px',
        },
      }}
      disabled={statusList.length > 0 ? false : true}
      onChange={(event, newValue) => {
        handleChange(event, newValue);
        // Reset TextField value when an option is selected
        event.target.value = '';
      }}
      options={statusList}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          fullWidth
          sx={{ height: '40px' }}
        />
      )}
      renderOption={(props, option) => {
        const isHighlighted = highlightedOptions.includes(option);
        return (
          <li
            {...props}
            style={{
              backgroundColor: isHighlighted ? '#ffe426' : 'white',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            {' '}
            <Box>{option.text}</Box>
            {isHighlighted && (
              <img src="Images/icon-check.png" alt="icon-check" />
            )}
          </li>
        );
      }}
    />
  );
};
